class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.dataset.loaded === 'true') return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    }, { rootMargin: '0px 0px 300px 0px' });

    observer.observe(this);
  }

  async loadRecommendations() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const incoming = html.querySelector('[data-recommendations]');
      if (!incoming || !incoming.innerHTML.trim()) return;
      this.innerHTML = incoming.innerHTML;
      this.dataset.loaded = 'true';
      document.dispatchEvent(new CustomEvent('econosmart:content-updated', { detail: { source: 'recommendations' } }));
    } catch (error) {
      console.error('EconoSmart recommendations failed:', error);
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
